module.exports = __webpack_public_path__ + "static/media/illustration-upload-cloud.cfb9f1a4.svg";